import { ODOO_BASE_URL } from "./constants";
export function getOdooRecordUrl(record) {
    return getOdooModelUrl(record.model, record.id);
}
export function getOdooModelUrl(model, id) {
    const params = new URLSearchParams({
        id: String(id),
        model,
        view_type: "form"
    });
    return `${ODOO_BASE_URL}/web#${params.toString()}`;
}
